var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1056 0H0.782609C0.335404 0 0 0.335404 0 0.782609V17.2174C0 17.5528 0.335404 17.8882 0.782609 17.8882H17.2174C17.6646 17.8882 18 17.5528 18 17.1056V0.782609C17.8882 0.335404 17.5528 0 17.1056 0ZM5.25478 15.205H2.68335V6.70808H5.36658V15.205H5.25478ZM4.02493 5.59006C3.13052 5.59006 2.45972 4.80746 2.45972 4.02485C2.45972 3.13044 3.13052 2.45963 4.02493 2.45963C4.91934 2.45963 5.59015 3.13044 5.59015 4.02485C5.47835 4.80746 4.80754 5.59006 4.02493 5.59006ZM15.2049 15.205H12.5217V11.0683C12.5217 10.0621 12.5217 8.8323 11.1801 8.8323C9.83847 8.8323 9.61487 9.95031 9.61487 11.0683V15.3168H6.93164V6.70808H9.50307V7.82609C9.83847 7.15528 10.7329 6.48447 11.9627 6.48447C14.6459 6.48447 15.0931 8.27329 15.0931 10.5093V15.205H15.2049Z",
    fill: "#652784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.12a807937edd5fd4d9001e3e83710c1c.svg";
export { ForwardRef as ReactComponent };